import { api } from '../../DefaultService';
import {
  ITotvsIENHCreateProps,
  ITotvsIENHProps,
  ITotvsIENHUpdateParams,
} from './types';

const ENDPOINT = '/v1/integrations/totvsIENH';

export const createTotvsIENHIntegrationAsync = async (
  data: ITotvsIENHCreateProps,
) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllTotvsIENHIntegrationsAsync = async (): Promise<
  ITotvsIENHProps[]
> => {
  return await api
    .get<ITotvsIENHProps[]>(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getTotvsIENHIntegrationByIdAsync = async (
  id: number,
): Promise<ITotvsIENHProps> => {
  return await api
    .get<ITotvsIENHProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateTotvsIENHIntegrationAsync = async ({
  id,
  data,
}: ITotvsIENHUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteTotvsIENHIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
